import * as React from "react";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import usePluginEntities from "hooks/usePluginEntities";
import { Row, Col, Button, Label } from "components/bootstrap";
import useScopePermissions from "hooks/useScopePermissions";
import { SummaryRow, Title, Value } from "./caches/SummaryComponents.styled";
const Cache = ({ cache, noEdit = false }) => {
  const { t } = useTranslation("lookup_tables");
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(cache);
  const plugin = usePluginEntities("lookupTableCaches").find((p) => {
    var _a;
    return p.type === ((_a = cache.config) == null ? void 0 : _a.type);
  });
  const { push } = useHistory();
  const canEdit = !noEdit && !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable);
  if (!plugin) {
    return /* @__PURE__ */ React.createElement("p", null, t("cache_summary.unknown_type", { type: cache.config.type }));
  }
  const handleEdit = () => {
    push(Routes.SYSTEM.LOOKUPTABLES.CACHES.edit(cache.name));
  };
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement(Label, null, plugin.displayName), canEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: handleEdit, role: "button", name: "edit_square" }, t("common:actions.edit"))), /* @__PURE__ */ React.createElement(SummaryRow, null, /* @__PURE__ */ React.createElement(Title, null, t("shared.description_colon")), /* @__PURE__ */ React.createElement(Value, null, cache.description || /* @__PURE__ */ React.createElement("em", null, t("shared.no_description")))), /* @__PURE__ */ React.createElement("h4", null, t("shared.configuration")), /* @__PURE__ */ React.createElement("div", null, React.createElement(plugin.summaryComponent, { cache }))));
};
export default Cache;
